/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

class Identity {
    constructor(properties = null) {
        this.properties = properties;
    }

    track() {
        try {
            if (!this.properties) {
                return null;
            }

            return this.properties.toJSON ? this.properties.toJSON() : {};
        } catch (error) {
            console.error(`Validation failed: ${error.message}`);
        }
    }
}

export default Identity;
